<dx-popup [title]="'remotePlatforms.lblSftpServer' | translate" [(visible)]="visible" (onShown)="onShown()" (onHidden)="onHidden()">
    <div *dxTemplate="let data of 'content'">
        <dx-progress-bar width="100%"
                         [height]="15"
                         [value]="false"
                         [visible]="isProgressBarVisible" />
        <dx-scroll-view>
            <dx-validation-group #remotePlatformValidation>
                <div class="dx-fieldset">
                    <div class="dx-fieldset-header" translate>_commons.information</div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>remotePlatforms.lblDisabled</div>
                        <div class="dx-field-value">
                            <dx-switch [(value)]="platform.isDisabled" [(readOnly)]="readOnly"></dx-switch>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>remotePlatforms.lblUseIpWorksEngine</div>
                        <div class="dx-field-value">
                            <dx-switch [(value)]="platform.useIpWorksEngine" [(readOnly)]="readOnly"></dx-switch>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>
                            remotePlatforms.lblName<span class="dx-field-item-required-mark" *ngIf="!readOnly"> *</span>
                        </div>
                        <div class="dx-field-value">
                            <dx-text-box [(value)]="platform.name" [(readOnly)]="readOnly">
                                <dx-validator>
                                    <dxi-validation-rule type="required" [message]="'remotePlatforms.msgNameRequired' | translate"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>
                            remotePlatforms.lblServer<span class="dx-field-item-required-mark" *ngIf="!readOnly"> *</span>
                        </div>
                        <div class="dx-field-value">
                            <dx-text-box [(value)]="platform.server" [(readOnly)]="readOnly">
                                <dx-validator>
                                    <dxi-validation-rule type="required" [message]="'remotePlatforms.msgServerRequired' | translate"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>remotePlatforms.lblPort</div>
                        <div class="dx-field-value">
                            <dx-text-box [(value)]="platform.port" [(readOnly)]="readOnly" [width]="150" [inputAttr]="{ 'style': 'text-align: right !important;' }"></dx-text-box>
                        </div>
                    </div>
                </div>
                <div class="dx-fieldset">
                    <div class="dx-fieldset-header" translate>_commons.security</div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>
                            remotePlatforms.lblAccount<span class="dx-field-item-required-mark" *ngIf="!readOnly"> *</span>
                        </div>
                        <div class="dx-field-value">
                            <dx-text-box [(value)]="platform.account" [(readOnly)]="readOnly">
                                <dx-validator>
                                    <dxi-validation-rule type="required" [message]="'remotePlatforms.msgAccountRequired' | translate"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                    </div>
                    <div class="dx-field" *ngIf="readOnly">
                        <div class="dx-field-label" translate>remotePlatforms.lblAuthentication</div>
                        <div class="dx-field-value">
                            <dx-text-box [readOnly]="true" [value]="getAuthenticationModeLabel()"></dx-text-box>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>remotePlatforms.lblIpFiltering</div>
                        <div class="dx-field-value">
                            <dx-switch [(value)]="platform.ipFiltering" [(readOnly)]="readOnly"></dx-switch>
                        </div>
                    </div>
                    <div class="dx-field" *ngIf="!readOnly">
                        <div class="dx-field-label" translate>remotePlatforms.lblAuthenticationType</div>
                        <div class="dx-field-value">
                            <dx-switch class="switch-two-on"
                                       [(readOnly)]="readOnly"
                                       [(value)]="authenticateBySshKey"
                                       [switchedOffText]="'remotePlatforms.lblPassword' | translate"
                                       [switchedOnText]="'remotePlatforms.lblSSHKey' | translate"
                                       (onValueChanged)="onAuthenticationChanged($event)"></dx-switch>
                        </div>
                    </div>
                    <div class="dx-field" *ngIf="!readOnly && !authenticateBySshKey">
                        <div class="dx-field-label" translate>
                            remotePlatforms.lblPassword<span class="dx-field-item-required-mark" *ngIf="!readOnly && !this.platform.id"> *</span>
                        </div>
                        <div class="dx-field-value">
                            <dx-text-box [(value)]="platform.password" mode="password" [placeholder]="getPasswordPlaceHolder()">
                                <dx-validator>
                                    <dxi-validation-rule type="custom" [reevaluate]="true" [validationCallback]="validateCredentials" [message]="'remotePlatforms.msgPasswordRequired' | translate"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                    </div>
                    <div class="dx-field" *ngIf="!readOnly && authenticateBySshKey">
                        <div class="dx-field-label" translate>remotePlatforms.lblSSHKey<span class="dx-field-item-required-mark" *ngIf="!readOnly && !this.platform.id"> *</span></div>
                        <div class="dx-field-value">
                            <dx-file-uploader #sshKeySelector 
                                              uploadMode="useForm"
                                              [labelText]="'remotePlatforms.lblOrDropFileHere' | translate"
                                              [selectButtontext]="'remotePlatforms.lblSelectSshKey' | translate" >
                                <dx-validator>
                                    <dxi-validation-rule type="custom" [reevaluate]="true" [validationCallback]="validateCredentials" [message]="'remotePlatforms.msgSshKeyRequired' | translate"></dxi-validation-rule>
                                </dx-validator>
                            </dx-file-uploader>
                        </div>
                    </div>
                    <div class="dx-field" *ngIf="!readOnly && authenticateBySshKey">
                        <div class="dx-field-label" translate>remotePlatforms.lblSSHKeyPassword</div>
                        <div class="dx-field-value">
                            <dx-text-box [(value)]="platform.sshKeyPassword" mode="password" [placeholder]="getPasswordPlaceHolder()"></dx-text-box>
                        </div>
                    </div>
                </div>
            </dx-validation-group>
        </dx-scroll-view>
        <div class="flex bottom-buttons leftButtons" *ngIf="!readOnly">
            <dx-button *ngIf="!readOnly" class="save leftButton" [text]="'_commons.save' | translate" (onClick)="loadSshKeyAndSave()"></dx-button>
            <dx-button class="cancel leftButton" [text]="'_commons.cancel' | translate" (onClick)="this.visible = false"></dx-button>
        </div>
        <div class="flex bottom-buttons" *ngIf="readOnly">
            <dx-button class="close closeButton" [text]="'_commons.close' | translate" (onClick)="this.visible = false"></dx-button>
        </div>
    </div>
</dx-popup>